/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/prop-types */
import { Typography } from '@material-ui/core';
import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import CountyContext from '../../contexts/CountyContext';
import StoryContext from '../../contexts/StoryContext';
import { rdsSelect } from '../../modules/rds';
import states, { stateFIPS } from '../../modules/states';
import { toPercent } from '../../modules/text';
import BarChart from '../BarChart';
import { getRatesByState } from './data';

function PriceOfChildcareVsPriceOfHousing({ height = 300 }) {
  const { stateCode } = useParams();
  const [ready, setReady] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState([]);
  const { countyCode, county } = useContext(CountyContext);
  const { primaryColor, secondaryColor } = useContext(StoryContext);

  useEffect(() => {
    setError(null);
    // function getRatesByState() {
    //   let whereClause = `state_fips=${stateFIPS[stateCode.toUpperCase()]}`;
    //   whereClause += composeWhereClause({});

    //   if (countyCode) {
    //     whereClause += ` AND county_fips=${countyCode}`;
    //   }

    //   return rdsTabulate('ccdc', 'county_setting_group_rate_annual', {
    //     dims: 'state',
    //     measure: 'average_rate:AVG(rate)',
    //     where: whereClause,
    //     format: 'amcharts',
    //     inject: true,
    //   }, true);
    // }

    function getMedianHouseholdIncomeAndHousing() {
      let dataProduct = 'acs_sams_state_wide';
      let where = `state_fips=${stateFIPS[stateCode.toUpperCase()]}`;
      if (countyCode) {
        dataProduct = 'acs_sams_county_wide';
        where += ` AND county_fips=${countyCode} AND (county_suppressed=0 OR county_suppressed=NULL)`;
      }
      return rdsSelect('3rdparty', dataProduct, {
        cols: ['inc_fam_married', 'inc_fam_nospouse', 'cost_housing_married', 'cost_housing_other_fam'].join(','),
        where,
        format: 'amcharts',
        inject: false,
      });
    }

    if (stateCode && states[stateCode.toUpperCase()]) {
      Promise.all([getRatesByState(stateCode, countyCode), getMedianHouseholdIncomeAndHousing()])
        .then((responses) => {
          const rate = responses[0].parsedBody.dataProvider[0].average_rate;

          const incomes = responses[1].parsedBody.dataProvider[0];
          setData([
            { groupKey: 'Child Care', 'Married-couple families': (rate / incomes.inc_fam_married), 'Single-parent families': (rate / incomes.inc_fam_nospouse) },
            { groupKey: 'Housing', 'Married-couple families': ((incomes.cost_housing_married * 12) / incomes.inc_fam_married), 'Single-parent families': ((incomes.cost_housing_other_fam * 12) / incomes.inc_fam_nospouse) },
          ]);
        })
        .catch((err) => {
          setError(err);
        })
        .finally(() => {
          setReady(true);
        });
    }
  }, [stateCode, countyCode]);

  const keys = ['Married-couple families', 'Single-parent families'];
  const groupKey = 'groupKey';

  let title = 'Price of Child Care vs. Price of Housing';
  if (county) {
    title += ` - ${county} County`;
  }

  const formatterFunction = function formatterFunction(payload) {
    return `<b>${toPercent(payload.value)}</b> of the household income for a <b>${payload.dataKey.toLowerCase().replace('families', 'family')}</b> 
    goes to pay for <b>${payload.payload.groupKey.toLowerCase()}</b>.`;
  };

  return (
    <>
      {error && <Typography variant="body1" color="error">{error.message}</Typography>}
      <BarChart
        valueFormatter={toPercent}
        formatterFunction={formatterFunction}
        height={height}
        ready={ready}
        data={data}
        keys={keys}
        groupKey={groupKey}
        title={title}
        colors={[primaryColor, secondaryColor]}
      />
    </>
  );
}

export default PriceOfChildcareVsPriceOfHousing;
